import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PersonComponent } from './pages/person/person.component';
import { DetailPersonComponent } from './component/detail-person/detail-person.component';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { authGuardLEMFn } from 'src/app/guards/auth.guard-lem';


const routes: Routes = [
  {
    path: '',
    data: { descrittore: NomiDescrittoriSezione.DESCRITTORE_RUBRICA },
    canActivate: [authGuardLEMFn],
    canActivateChild: [authGuardLEMFn],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: PersonComponent,
      },
      {
        path: 'dettaglio/:id',
        data: {title: "Persona - dettaglio"},
        component: DetailPersonComponent
      }
    ]
  }
];

@NgModule({
  declarations: [

  ],
  imports: [
    RouterModule.forChild(routes),

  ],
  exports: [RouterModule]
})
export class PersonRoutingModule { }
